import React, { useCallback } from "react";

import cn from "classnames";
import { useIntl } from "react-intl";

import FilterOperator from "@mapmycustomers/shared/enum/FilterOperator";
import {
  IFilterComponentProps,
  IFilterInstance,
} from "@mapmycustomers/shared/types/fieldModel/IFilterConfig";
import { NumberField, NumberFieldComponent } from "@mapmycustomers/ui";

import styles from "./NoContactFilter.module.scss";

export const NO_CONTACT_FILTER_OPERATORS = [
  FilterOperator.EQUALS,
  FilterOperator.GREATER_THAN,
  FilterOperator.GREATER_THAN_OR_EQUAL,
  FilterOperator.LESS_THAN,
  FilterOperator.LESS_THAN_OR_EQUAL,
];

interface NoContactFilterProps extends IFilterComponentProps {}

const NoContactFilter: IFilterInstance = {
  doesSupportValue: (value: any, operator: FilterOperator) => {
    return typeof value === "number" && NO_CONTACT_FILTER_OPERATORS.includes(operator);
  },
  getComponent:
    (): React.FunctionComponent<NoContactFilterProps> =>
    ({ className, disabled, focus, onChange, placeholder, value }) => {
      const intl = useIntl();

      const setRef = useCallback(
        (ref: null | NumberFieldComponent) => {
          if (focus && ref) {
            ref.focus();
          }
        },
        [focus]
      );

      return (
        <div className={cn(styles.container)}>
          <NumberField
            disabled={disabled}
            inputClassName={className}
            onChange={(number) => onChange?.({ ...value, value: number })}
            placeholder={placeholder as string}
            ref={setRef}
            size="middle"
            value={value?.value ?? ""}
          />
          <span className={styles.suffix}>
            {intl.formatMessage({
              id: "filters.noContact.suffix",
              defaultMessage: "days",
              description: "Days suffix in no contact field filter",
            })}
          </span>
        </div>
      );
    },
};

export default NoContactFilter;
